$(document).ready(function(){
    'use strict';

    const slider = $('.slider')

    //Настройки слайдера
    if (slider !== undefined) {
        slider.map(function () {

            $(this).slick({
                infinite: false,
                arrows: true,
                dots: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        })
    }

    /*$('.slider').slick({
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            // {
            //     breakpoint: 1024,
            //     settings: {
            //         variableWidth: true,
            //         slidesToShow: 3,
            //         slidesToScroll: 3,
            //         infinite: false,
            //         dots: false
            //     }
            // },
            {
                breakpoint: 500,
                settings: {
                    focusOnSelect: true,
                    // centerMode: true,
                    variableWidth: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });*/
});
